var lorem = {};
module['exports'] = lorem;
lorem.words = require("./words");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pt_BR/lorem/index.js
// module id = 1249
// module chunks = 0